import xshy from '../assets/image/huiyi.png'
import xxhy from '../assets/image/xxhy.png'
import zbfw from '../assets/image/zhibo.png'
import sjfw from '../assets/image/pingmiansheji.png'
import yxfw from '../assets/image/yiliao.png'
import mtfw from '../assets/image/any.png'
import wjjzyq from '../assets/image/jiangzhezhuchi.png'
import rjkf from '../assets/image/kaifaguanli.png'
export const lists = [{
        name: "线上会议",
        icon: xshy,
        path: '/doctorServe'
    },
    {
        name: "线下会议",
        icon: xxhy
    },
    {
        name: "直播服务",
        icon: zbfw
    },
    {
        name: "设计服务",
        icon: sjfw
    },
    {
        name: "医学服务",
        icon: yxfw
    },
    {
        name: "媒体服务",
        icon: mtfw
    },
    {
        name: "外籍讲者邀请",
        icon: wjjzyq
    },
    {
        name: "软件开发",
        icon: rjkf
    },
]


import mavin from '../assets/image/followWithInterest/mavin.png'
import enterprise from '../assets/image/followWithInterest/enterprise.png'
import society from '../assets/image/followWithInterest/society.png'
import fund from '../assets/image/followWithInterest/fund.png'
import media from '../assets/image/followWithInterest/media.png'
import periodical from '../assets/image/followWithInterest/periodical.png'
import implement from '../assets/image/followWithInterest/implement.png'
import enterpriseserve from '../assets/image/followWithInterest/enterpriseserve.png'
export const follow = [{
        name: "专家列表",
        img: mavin
    },
    {
        name: "企业列表",
        img: enterprise
    },
    {
        name: "学协会列表",
        img: society
    },
    {
        name: "媒体列表",
        img: media
    },
    {
        name: "期刊列表",
        img: periodical
    },
    {
        name: "执行方列表",
        img: implement
    },
    {
        name: "基金会列表",
        img: fund
    },
    {
        name: "外籍讲者列表",
        img: enterpriseserve
    },
]